import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { cn } from "@/core/utils/utils";
import { REFERRAL_COLUMN } from "@/referrals/constants";
import { ReferralColumn as ReferralColumnType } from "@/referrals/referral";

interface NumberOfReferralsProps {
  count: number;
  column: ReferralColumnType;
}

const REFERRAL_COLUMN_TO_COLOR = {
  [REFERRAL_COLUMN.new]: "bg-green-10",
  [REFERRAL_COLUMN.inProgress]: "bg-blue-10",
  [REFERRAL_COLUMN.scheduled]: "bg-purple-10",
  [REFERRAL_COLUMN.closed]: "bg-gold-10",
} as const;

const NumberOfReferrals = ({ count, column }: NumberOfReferralsProps) => (
  <Stack
    direction="row"
    align="center"
    justify="center"
    className={cn("h-6 w-6 rounded-full p-2", REFERRAL_COLUMN_TO_COLOR[column])}
  >
    <Typography variant="bodyW1">{count}</Typography>
  </Stack>
);

export default NumberOfReferrals;
